
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';

export default function ProductDetail() {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [selectedColor, setSelectedColor] = useState(0);
  const [selectedSize, setSelectedSize] = useState(1);
  const [isFavorite, setIsFavorite] = useState(false);

  const product = {
    name: 'طماطم طازجة - كيلو',
    price: '12',
    oldPrice: '15',
    rating: 4.8,
    reviews: 234,
    sold: 1250,
    description: 'طماطم طازجة عالية الجودة، مزروعة محلياً بدون مبيدات حشرية. غنية بالفيتامينات والمعادن الأساسية. مثالية للسلطات والطبخ والعصائر. يتم قطفها يومياً لضمان أقصى درجات النضارة والطعم الرائع.',
    features: [
      'طازجة يومياً من المزرعة',
      'خالية من المبيدات الحشرية',
      'غنية بفيتامين C والليكوبين',
      'مثالية للسلطات والطبخ',
      'تخزين في مكان بارد وجاف',
      'صالحة لمدة 5-7 أيام'
    ],
    colors: [
      { name: 'أحمر', value: '#DC2626' },
      { name: 'أحمر داكن', value: '#991B1B' },
      { name: 'برتقالي', value: '#EA580C' }
    ],
    sizes: ['صغير', 'متوسط', 'كبير'],
    images: [
      'https://public.readdy.ai/ai/img_res/82ae828f4c37a9df747072c64ba712db.jpg',
      'https://readdy.ai/api/search-image?query=Fresh%20red%20tomatoes%20on%20vine%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20vibrant%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=800&height=800&seq=proddetgro2&orientation=squarish',
      'https://readdy.ai/api/search-image?query=Fresh%20red%20tomatoes%20sliced%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20vibrant%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=800&height=800&seq=proddetgro3&orientation=squarish'
    ]
  };

  const [currentImage, setCurrentImage] = useState(0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-blue-50 pb-24" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h2 className="text-lg font-bold text-gray-800">تفاصيل المنتج</h2>
          <button className="w-10 h-10 flex items-center justify-center">
            <i className="ri-share-line text-2xl text-gray-800"></i>
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="pt-16">
        {/* Image Gallery */}
        <div className="relative">
          <div className="h-80 overflow-hidden">
            <img 
              src={product.images[currentImage]}
              alt={product.name}
              className="w-full h-full object-cover object-top"
            />
          </div>
          <button
            onClick={() => setIsFavorite(!isFavorite)}
            className="absolute top-4 left-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg"
          >
            <i className={`${isFavorite ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-gray-700'} text-xl`}></i>
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
            {product.images.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentImage(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                  currentImage === index ? 'w-6 bg-white' : 'bg-white/50'
                }`}
              />
            ))}
          </div>
        </div>

        {/* Product Info */}
        <div className="px-4 py-6 bg-white rounded-t-3xl -mt-6 relative z-10 shadow-lg">
          {/* Title & Price */}
          <div className="mb-4">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">{product.name}</h1>
            <div className="flex items-center gap-3 mb-3">
              <span className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">{product.price} ر.س</span>
              <span className="text-lg text-gray-400 line-through">{product.oldPrice} ر.س</span>
              <span className="px-3 py-1 bg-gradient-to-r from-red-500 to-pink-500 text-white text-sm font-bold rounded-full">-20%</span>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-1">
                <i className="ri-star-fill text-yellow-400"></i>
                <span className="font-bold text-gray-800">{product.rating}</span>
                <span className="text-gray-400 text-sm">({product.reviews} تقييم)</span>
              </div>
              <div className="flex items-center gap-1 text-gray-600">
                <i className="ri-shopping-bag-line"></i>
                <span className="text-sm">{product.sold} مبيعات</span>
              </div>
            </div>
          </div>

          {/* Colors */}
          <div className="mb-4">
            <h3 className="text-sm font-bold text-gray-800 mb-3">درجة النضج</h3>
            <div className="flex gap-3">
              {product.colors.map((color, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedColor(index)}
                  className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                    selectedColor === index ? 'ring-2 ring-blue-500 ring-offset-2' : ''
                  }`}
                  style={{ backgroundColor: color.value }}
                >
                  {selectedColor === index && (
                    <i className="ri-check-line text-xl text-white"></i>
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Sizes */}
          <div className="mb-4">
            <h3 className="text-sm font-bold text-gray-800 mb-3">الحجم</h3>
            <div className="flex gap-3">
              {product.sizes.map((size, index) => (
                <button
                  key={index}
                  onClick={() => setSelectedSize(index)}
                  className={`px-6 py-2.5 rounded-xl font-medium text-sm transition-all duration-300 ${
                    selectedSize === index
                      ? 'bg-gradient-to-r from-blue-500 to-purple-500 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700'
                  }`}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>

          {/* Quantity */}
          <div className="mb-6">
            <h3 className="text-sm font-bold text-gray-800 mb-3">الكمية</h3>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center hover:bg-gray-200 transition-colors"
              >
                <i className="ri-subtract-line text-xl text-gray-700"></i>
              </button>
              <span className="text-xl font-bold text-gray-800 w-12 text-center">{quantity}</span>
              <button
                onClick={() => setQuantity(quantity + 1)}
                className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl flex items-center justify-center shadow-md"
              >
                <i className="ri-add-line text-xl text-white"></i>
              </button>
            </div>
          </div>

          {/* Description */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-800 mb-3">الوصف</h3>
            <p className="text-gray-600 leading-relaxed">{product.description}</p>
          </div>

          {/* Features */}
          <div className="mb-6">
            <h3 className="text-lg font-bold text-gray-800 mb-3">المميزات</h3>
            <div className="space-y-2">
              {product.features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-gradient-to-r from-green-400 to-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-white text-sm"></i>
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 px-4 py-4 z-50">
        <div className="flex gap-3">
          <Link
            to="/cart"
            className="flex-1 py-4 bg-white border-2 border-blue-500 text-blue-600 rounded-2xl font-bold text-center hover:bg-blue-50 transition-all duration-300"
          >
            أضف للسلة
          </Link>
          <Link
            to="/checkout"
            className="flex-1 py-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-2xl font-bold text-center shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            اشتر الآن
          </Link>
        </div>
      </div>
    </div>
  );
}
